/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Xml_Feed_SetupInputs */

const cs_xml_feed_setup = /** @type {(inputs: Xml_Feed_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořit feed`)
};

const en_xml_feed_setup = /** @type {(inputs: Xml_Feed_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create feed`)
};

/**
* | output |
* | --- |
* | "Create feed" |
*
* @param {Xml_Feed_SetupInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const xml_feed_setup = /** @type {((inputs?: Xml_Feed_SetupInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Xml_Feed_SetupInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_xml_feed_setup(inputs)
	return cs_xml_feed_setup(inputs)
});